module.exports = __webpack_public_path__ + "img/glass.76144c3a.png";